import { render, staticRenderFns } from "./UpcomingEventSummary.vue?vue&type=template&id=1c8cff9e&scoped=true&"
import script from "./UpcomingEventSummary.vue?vue&type=script&lang=js&"
export * from "./UpcomingEventSummary.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingEventSummary.vue?vue&type=style&index=0&id=1c8cff9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8cff9e",
  null
  
)

export default component.exports